/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Global
import { useEffect, useState } from 'react';
import { tv } from 'tailwind-variants';
import useDictionary from 'lib/hooks/useDictionary';
import { withStandardComponentWrapper } from 'helpers/HOC';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { getTestProps } from 'lib/testing/utils';
import { useSetIsDataAvailable } from 'lib/context/IsDataAvailableContext';
import useIsEditing from 'lib/hooks/useIsEditing';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const Tags = (props)=>{
    const { getDictionaryValue } = useDictionary();
    const { container, blockContainer, heading, listWrapper } = TAILWIND_VARIANTS();
    const [tags, setTags] = useState([]);
    const isEditing = useIsEditing();
    const setIsDataAvailable = useSetIsDataAvailable();
    useEffect(()=>{
        const fetchTags = ()=>{
            const tagsListString = props?.fields?.tagsList?.value || '';
            const tagsList = tagsListString.split('|').map((tag)=>tag.trim()).filter((tag)=>tag.length > 0).map((tag)=>({
                    label: tag,
                    url: undefined
                }));
            const available = !isEditing && (tagsList?.length ?? 0) > 0;
            setIsDataAvailable(available);
            setTags(tagsList || []);
        };
        // Only run client-side
        if ("object" !== 'undefined') {
            fetchTags();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props?.fields?.tagsList?.value
    ]);
    // Get optional link field
    const mainLink = props?.fields?.link?.value;
    return /*#__PURE__*/ _jsx("section", {
        "data-component": "authorable/shared/content/tags",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-tags-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: container(),
            children: tags && tags.length > 0 && /*#__PURE__*/ _jsxs("div", {
                className: blockContainer(),
                children: [
                    getDictionaryValue('TagsTitle')?.trim() ? /*#__PURE__*/ _jsx("h2", {
                        className: heading(),
                        children: getDictionaryValue('TagsTitle')
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        className: listWrapper(),
                        children: tags.map((item, index)=>{
                            return /*#__PURE__*/ _jsx(TagListItem, {
                                tagKey: `tag-${index}`,
                                item: item,
                                mainLinkHref: mainLink?.href
                            });
                        })
                    })
                ]
            })
        })
    });
};
const TagListItem = ({ item, tagKey, mainLinkHref })=>{
    const { listItem, linkItemClasses } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: mainLinkHref ? /*#__PURE__*/ _jsx("div", {
            className: listItem(),
            id: tagKey,
            children: /*#__PURE__*/ _jsx(LinkWrapper, {
                className: linkItemClasses(),
                ctaVariant: 'custom',
                field: {
                    value: {
                        href: mainLinkHref,
                        querystring: `searchTag=${item.label}`,
                        text: item.label
                    }
                },
                ctaComponentClass: "default",
                suppressNewTabIcon: true
            })
        }) : /*#__PURE__*/ _jsx("div", {
            className: listItem(),
            id: tagKey,
            children: /*#__PURE__*/ _jsx("span", {
                className: linkItemClasses(),
                children: item.label
            })
        })
    });
};
export const Default = withStandardComponentWrapper(Tags, false);
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'my-2'
        ],
        blockContainer: [
            'w-full',
            'p-padding-loose',
            'bg-component-Profile-Block-surface',
            'rounded-general-border-radius-card',
            'shadow-color-black-alpha-10',
            'shadow-[0_0_8px_0]',
            'flex',
            'flex-col',
            'gap-padding-base'
        ],
        heading: [
            'w-full',
            'text-component-Tags-title',
            'font-typography-font-family-body',
            'text-typography-font-size-body-xlarge',
            'leading-typography-line-height-body-xlarge',
            'font-semibold',
            'pb-padding-base',
            'border-b',
            'border-color-border-border'
        ],
        listWrapper: [
            'w-full',
            'grid',
            'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
            'gap-y-padding-micro gap-x-layout-base-margin-x'
        ],
        listItem: [
            'w-full',
            'py-spacing-spacing-1',
            'text-component-Profile-Block-list-item',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'leading-typography-line-height-body-medium'
        ],
        linkItemClasses: [
            'w-fit',
            'font-normal',
            'text-component-Profile-Block-list-item',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'leading-typography-line-height-body-medium',
            'hover:underline',
            'focus:underline',
            'focus:bg-component-button-tertiary-bg-focused'
        ]
    }
});
